import React from 'react';
import {useSelector} from 'react-redux';

import {useStateHook} from 'front-onceforall-core/dist/utils/customHooks';

import {captureError} from '../../../../utils/log';
import subscriptionService from '../../../../services/subscription/SubscriptionService';

import {useUsersStore} from '../UsersStore';

import HeaderView from './HeaderView';
import UserAddPanel from './userAddPanel';

function HeaderContainer() {
  const organisation = useSelector(globalState => globalState.organisation);
  const {state: usersStore, dispatch} = useUsersStore();
  const [state, setState] = useStateHook({
    isPanelOpen: false,
    hasSubscription: false,
    userSlotsLeft: 0
  });

  React.useEffect(() => {
    async function getUserSubscription() {
      try {
        const subscription = await subscriptionService.findSubscriptionByOrganisation(organisation.organisationId);
        setState({
          hasSubscription: Boolean(subscription),
          userSlotsLeft: subscription ? subscription.maximumNumberOfUserAccounts - subscription.numberOfUserAccounts : 0
        });
      } catch (error) {
        captureError('Error while fetching subscription', error);
      }
    }

    getUserSubscription();
  }, [organisation.organisationId, JSON.stringify(usersStore.users)]);

  return (
    <>
      <HeaderView
        onAddClient={() => setState({isPanelOpen: true})}
        hasSubscription={state.hasSubscription}
        userSlotsLeft={state.userSlotsLeft}
      />
      <UserAddPanel
        userSlotsLeft={state.userSlotsLeft}
        isOpen={state.isPanelOpen}
        onClose={() => {
          setState({isPanelOpen: false});
          dispatch({type: 'FETCH_USERS'});
        }}
      />
    </>
  );
}

export default HeaderContainer;
